module.exports = __webpack_public_path__ + "media/images/nav-7f4a3239.png";